import { useMemo, useState } from 'react';
import { TransactionResultStatus } from 'components';
import { BaseStxmapModel, IPagination } from 'types';

export const useStxmapTab = () => {
  const [isLoading, setLoading] = useState(false);
  const [searchStxMapResult, setSearchStxMapResult] = useState<BaseStxmapModel[] | undefined>();
  const [currentPage, setCurrentPage] = useState(0);
  const [pagination, setPagination] = useState<IPagination>();
  const [transferredAsset, setTransferredAsset] = useState('');
  const [instantSendDialogShown, setInstantSendDialogShown] = useState(false);
  const [transactionMessagePopupShown, setTransactionMessagePopupShown] = useState(false);
  const [transactionResultStatus, setTransactionResultStatus] = useState<TransactionResultStatus>();
  const [transactionResultMessage, setTransactionResultMessage] = useState('');

  return useMemo(
    () => ({
      isLoading,
      setLoading,
      searchStxMapResult,
      setSearchStxMapResult,
      currentPage,
      setCurrentPage,
      pagination,
      setPagination,
      transferredAsset,
      setTransferredAsset,
      instantSendDialogShown,
      setInstantSendDialogShown,
      transactionMessagePopupShown,
      setTransactionMessagePopupShown,
      transactionResultStatus,
      setTransactionResultStatus,
      transactionResultMessage,
      setTransactionResultMessage,
    }),
    [
      isLoading,
      searchStxMapResult,
      currentPage,
      pagination,
      transferredAsset,
      instantSendDialogShown,
      transactionMessagePopupShown,
      transactionResultStatus,
      transactionResultMessage,
    ]
  );
};
